var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"form",staticClass:"ui form"},[_c('div',{staticClass:"field"},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t("logo")))]),_c('file-pond',{ref:"file",attrs:{"name":"bill_file","label-idle":_vm.$t('click or drop files here'),"allow-multiple":false,"allow-revert":false,"server":{
        url: _vm.api_host,
        timeout: _vm.enterprise_setup.upload_timeout,
        process: {
          url: '/nvidia_bundle/store/do-upload-logo',
          method: 'POST',
          headers: {
            'x-access-token': _vm.token_session,
          },
          withCredentials: false,
        },
      }},on:{"error":_vm.filepond_error,"processfile":_vm.filepond_process}})],1),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.logo && _vm.logo.relative_path),expression:"logo && logo.relative_path"}],staticClass:"field"},[_c('label',{attrs:{"for":""}},[_vm._v(_vm._s(_vm.$t("preview")))]),_c('img',{staticClass:"ui centered medium image",attrs:{"src":_vm.api_host + '/' + _vm.logo.relative_path}})]),_c('div',{staticClass:"ui error message"})])
}
var staticRenderFns = []

export { render, staticRenderFns }